import axios from "axios";
// 创建 axios 实例
const request = axios.create({
    // API 请求的默认前缀
    // baseURL: process.env.REACT_APP_ENV === 'production' ? 'https://mgbackend.naloasd.top' :  process.env.REACT_APP_ENV === 'production02' ? 'https://mgbk02.naloasd.top': process.env.REACT_APP_ENV === 'production03' ? 'https://mgbk03.naloasd.top': process.env.REACT_APP_ENV === 'production04' ? 'https://ngabk.naloasd.top' : process.env.REACT_APP_ENV === 'production05' ? 'https://dakarbk.naloasd.top' : 'http://127.0.0.1:8080',
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 100000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
    if (error.response) {
        if (error.response.status === 403) {
            console.log('==========403==========')
        }
        if (error.response.status === 401) {
            console.log('==========401==========')
        }
    }
    return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
    // const token = storage.get(ACCESS_TOKEN)
    // // 如果 token 存在
    // // 让每个请求携带自定义 token 请根据实际情况自行修改
    // if (token) {
    //     // config.headers. = token
    //     config.headers['Authorization'] = 'Bearer ' + token
    //     config.headers[ENTERPRISE_ID] = getLocalEnterpriseId()
    // }
    return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
    return response.data
}, errorHandler)

export default request
